const chatNew = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M14 8c0-.6.4-1 1-1s1 .4 1 1v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h6c.6 0 1 .4 1 1s-.4 1-1 1H2v12h12zm-7.7.3 8-8c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-8 8c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4" clip-rule="evenodd"/></svg>',
};

export { chatNew as default };
